import type { MessageKey } from "./ru"

export const msMessages = {
  "common.loading": "Memuatkan...",
  "common.error": "Ralat",
  "common.back": "Kembali",
  "common.next": "Seterusnya",
  "common.search": "Cari",
  "auth.loginErrorTitle": "Ralat log masuk",
  "auth.openViaTelegram": "Buka aplikasi melalui Telegram",
  "auth.telegramRequired": "Aplikasi mesti dibuka melalui Telegram",
  "auth.authorizationError": "Ralat kebenaran",
  "device.rotatePortrait": "Putar peranti ke mod potret",
  "country.brazil": "Brazil",
  "country.vietnam": "Vietnam",
  "country.egypt": "Mesir",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Sepanyol",
  "country.italy": "Itali",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Colombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Mexico",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Rusia",
  "country.usa": "Amerika Syarikat",
  "country.turkey": "Türkiye",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Filipina",
  "countrySelection.chooseCountry": "Pilih negara",
  "countrySelection.openAria": "Pilih negara",
  "languageSelection.chooseLanguage": "Pilih bahasa",
  "commercial.direction.autotrade": "Pasaran Auto",
  "commercial.direction.insurance": "Insurans",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Bantuan Jalan Raya",
  "commercial.searchLabel": "Carian BeepApp",
  "commercial.cityPlaceholder": "Masukkan bandar",
  "commercial.emptyTitle": "Tiada tawaran hari ini",
  "commercial.emptyLine1": "Belum ada rakan kongsi BeepApp yang aktif di bandar anda",
  "commercial.emptyLine2": "Kami sedang berusaha mencari dan menghubungkan mereka",
  "commercial.emptyLine3": "Tawaran baharu akan muncul di sini secara automatik",
  "commercial.helperLine1": "Masukkan bandar anda untuk melihat",
  "commercial.helperLine2": "tawaran yang tersedia",
  "commercial.partnerPrompt": "Mahu menjadi rakan kongsi BeepApp?",
  "commercial.apply": "Mohon",
  "main.admin": "Admin",
  "main.garage": "Garaj",
  "main.signalSent": "Isyarat dihantar",
  "main.partnerInviteUnavailable": "Jemputan rakan kongsi tidak tersedia",
  "main.enterPlate": "Masukkan nombor pendaftaran",
  "main.searchError": "Ralat carian",
  "main.signalSendError": "Gagal menghantar isyarat",
  "main.shareCardPrefix": "Kad nombor pendaftaran",
  "main.shareLinkError": "Tidak dapat menyediakan pautan",
  "main.searchByPlateAria": "Cari mengikut nombor pendaftaran",
  "main.russianPlateAria": "Nombor pendaftaran Rusia",
  "main.plateAria": "Nombor pendaftaran",
  "main.findPlateAria": "Cari nombor",
  "main.loadingVehicle": "Memuatkan kad nombor pendaftaran…",
  "main.leaveSignal": "Hantar isyarat",
  "main.share": "Kongsi",
  "signalSelection.chooseType": "Pilih jenis isyarat",
  "signalSelection.category.attention": "Peribadi",
  "signalSelection.category.road": "Jalan raya",
  "signalSelection.category.urgent": "Segera",
  "signalSelection.chooseSignal": "Pilih isyarat",
  "signalSelection.suggestOwn": "Cadangkan pilihan anda",
  "signalConfirmation.title": "Sahkan isyarat",
  "signalConfirmation.plateHeading": "Semak nombor pendaftaran",
  "signalConfirmation.signalHeading": "Semak isyarat yang dipilih",
  "signalConfirmation.replyTitle": "Benarkan balasan di Telegram",
  "signalConfirmation.replyBody": "Aktifkan fungsi ini supaya pemilik nombor boleh\nmenghantar mesej kepada anda di Telegram. Balasan hanya boleh\ndilakukan jika anda mempunyai @username. Keputusan untuk membalas\nterpulang kepada pemilik nombor.",
  "signalConfirmation.consentText": "Saya mengesahkan bahawa isyarat ini berkaitan\ndengan situasi sebenar dan bukan spam\natau laporan palsu.",
  "signalConfirmation.warning": "Selepas dihantar, isyarat\ntidak boleh diubah",
  "signalConfirmation.sending": "Menghantar…",
  "signalConfirmation.send": "Hantar",
  "partner.loadingAria": "Memuatkan",
  "partner.title": "Program Rakan Kongsi",
  "partner.offerLine1": "Terima 30% daripada semua bayaran tanpa had masa",
  "partner.offerLine2": "daripada pengguna yang anda jemput ke BeepApp",
  "partner.offerLine3": "melalui program affiliate Telegram",
  "partner.connectUnavailable": "Sambungan akan tersedia selepas Program Affiliate Telegram dikonfigurasikan.",
  "partner.connectTelegram": "Sambung di Telegram",
  "partner.qrAria": "Kod QR pautan rakan kongsi",
  "partner.download": "Muat turun",
  "partner.promoHeading": "Cipta kod promosi peribadi",
  "partner.promoHelperLine1": "Kod promosi mengaktifkan tambahan satu tahun langganan",
  "partner.promoHelperLine2": "dan membantu menarik pengguna",
  "partner.promoAria": "Kod promosi",
  "partner.affiliateHeading": "Pautan affiliate anda",
  "partner.affiliateHelper": "Simpan pautan untuk mencipta kod QR peribadi",
  "partner.affiliateAria": "Pautan affiliate",
  "partner.qrNoteLine1": "Kod QR boleh diletakkan pada kenderaan,",
  "partner.qrNoteLine2": "di media sosial dan bahan pengiklanan",
  "partner.save": "Simpan",
  "partner.reset": "Tetapkan semula",
  "partner.resetConfirm": "Tetapkan semula pautan affiliate yang disimpan? Kod promosi kekal milik anda.",
  "partner.promoFormatError": "Kod promosi mesti mengandungi 4 hingga 15 aksara.",
  "partner.affiliateHostError": "Hanya pautan t.me atau telegram.me dibenarkan.",
  "partner.affiliatePathError": "Pautan tidak mengandungi laluan Telegram.",
  "partner.affiliateFormatError": "Pautan affiliate tidak sah.",
  "partner.loadError": "Ralat memuatkan",
  "partner.checkInputError": "Semak maklumat yang dimasukkan",
  "garageActivation.promoInvalid": "Kod promosi tidak sah",
  "garageActivation.plateOccupied": "Nombor pendaftaran ini sudah dipautkan",
  "garageActivation.activateError": "Tidak dapat mengaktifkan Garaj",
  "garageEntry.loadJournalError": "Tidak dapat memuatkan log",
  "garageEntry.loadStatusesError": "Tidak dapat memuatkan status",
  "garageEntry.activationSuccess": "Garaj berjaya diaktifkan",
  "garageEntry.plateAttached": "Nombor dipautkan",
  "garageEntry.attachError": "Tidak dapat memautkan nombor",
  "garageEntry.activationNote": "Aktifkan Garaj anda",
  "garageSheet.activationTitle": "Pengaktifan Garaj",
  "garageSheet.plateHelper": "Masukkan nombor pendaftaran kenderaan",
  "garageSheet.promoHelper": "Ada kod promosi?",
  "garageSheet.cleanBonusLine1": "Selepas pengaktifan, anda mempunyai 1 jam",
  "garageSheet.cleanBonusLine2": "untuk “Permulaan Bersih” percuma",
  "garageSheet.activationFor": "Pengaktifan untuk",
  "garageSheet.cost": "Kos",
  "garageSheet.ownerConsentLine1": "Saya mengesahkan bahawa saya pemilik",
  "garageSheet.ownerConsentLine2": "kenderaan dengan nombor pendaftaran",
  "garageSheet.ownerConsentLine3": "yang dinyatakan.",
  "garageSheet.processing": "Sedang diproses...",
  "garageSheet.attach": "Pautkan",
  "garageSheet.pay": "Bayar",
  "garageLifecycle.cleanTitle": "Permulaan Bersih",
  "garageLifecycle.deactivateTitle": "Nyahaktif Garaj",
  "garageLifecycle.cleanWarningLine1": "Sejarah nombor akan dipadam",
  "garageLifecycle.cleanWarningLine2": "tanpa kemungkinan pemulihan!",
  "garageLifecycle.deactivateWarningLine1": "Selepas dinyahaktifkan, akses kepada fungsi",
  "garageLifecycle.deactivateWarningLine2": "Garaj aktif akan ditamatkan",
  "garageLifecycle.willBeDeleted": "AKAN DIPADAM",
  "garageLifecycle.cleanRemovedLine1": "• Semua catatan dalam Log",
  "garageLifecycle.cleanRemovedLine2": "• Sejarah isyarat yang diterima",
  "garageLifecycle.cleanRemovedLine3": "• Kaunter isyarat awam",
  "garageLifecycle.cleanRemovedLine4": "  pada kad nombor",
  "garageLifecycle.willRemain": "AKAN KEKAL",
  "garageLifecycle.cleanPreservedLine1": "• Pautan nombor kepada Garaj",
  "garageLifecycle.cleanPreservedLine2": "• Tempoh pengaktifan yang berbaki",
  "garageLifecycle.cleanPreservedLine3": "• Status nombor yang dipilih",
  "garageLifecycle.cleanPreservedLine4": "• Jumlah tontonan kad nombor",
  "garageLifecycle.freeFirstHour": "Percuma pada jam pertama",
  "garageLifecycle.willBecomeUnavailable": "AKAN MENJADI TIDAK TERSEDIA",
  "garageLifecycle.deactivateRemovedLine1": "• Log",
  "garageLifecycle.deactivateRemovedLine2": "• Pemilihan dan penggunaan status nombor",
  "garageLifecycle.deactivateRemovedLine3": "• Anda akan keluar daripada AutoClan secara automatik",
  "garageLifecycle.deactivateRemovedLine4": "• Pasaran Auto",
  "garageLifecycle.deactivateRemovedLine5": "• Insurans",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Bantuan Jalan Raya",
  "garageLifecycle.deactivateRemovedLine8": "• Nombor pendaftaran akan dinyahpaut daripada Garaj",
  "garageLifecycle.willRemainAvailable": "AKAN KEKAL TERSEDIA",
  "garageLifecycle.deactivatePreservedLine1": "• Penumpang",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Carian mengikut nombor pendaftaran dan melihat",
  "garageLifecycle.deactivatePreservedLine4": "  kad kenderaan awam",
  "garageLifecycle.deactivatePreservedLine5": "• Keupayaan untuk mengaktifkan semula",
  "garageLifecycle.deactivatePreservedLine6": "  Garaj pada bila-bila masa",
  "garageLifecycle.cleanConsentLine1": "Saya bersetuju untuk memadam",
  "garageLifecycle.cleanConsentLine2": "keseluruhan sejarah nombor ini",
  "garageLifecycle.cleanConsentLine3": "tanpa kemungkinan pemulihan.",
  "garageLifecycle.deactivateConsentLine1": "Saya mengesahkan penyahaktifan dan",
  "garageLifecycle.deactivateConsentLine2": "penamatan akses kepada semua",
  "garageLifecycle.deactivateConsentLine3": "fungsi Garaj aktif.",
  "garageLifecycle.clean": "Kosongkan",
  "garageLifecycle.deactivate": "Nyahaktif",
} satisfies Record<MessageKey, string>
